import axios from '@/api/api-request'

const projectUrl = '/webTestContent'

// 管理-保存委托单填写信息(上一步)
export const getInfo = (params) => {
  return axios.request({
    url: projectUrl + '/getInfo.do',
    method: 'post',
    params: params
  })
}
// 管理-保存委托单填写信息(上一步)
export const getLists = (data) => {
  return axios.request({
    url: projectUrl + '/getLists.do',
    method: 'post',
    data: data
  })
}
